import { CATEGORY_ORDER, DECISION_ORDER } from './constants';

export const byCategoryOrdered = (decisions, definitions) => {
    const result = CATEGORY_ORDER.reduce((acc, category) => {
        acc[category] = {};
        Object.entries(DECISION_ORDER[category]).forEach(([subcategory, names]) => {
            acc[category][subcategory] = {};
            names.forEach(name => {
                const definition = definitions.find(def => def.name === name);
                const decision = {
                    ...definition,
                    values: [],
                };
                delete decision.value;
                acc[category][subcategory][name] = decision;
            });
        });
        return acc;
    }, {});

    Object.entries(decisions).forEach(([round, roundDecisions]) => {
        Object.entries(roundDecisions).forEach(([name, decision]) => {
            const dec = result[decision.category][decision.subcategory][name];
            dec.values.push(decision.value)
        });
    });

    return result;
};